import {EntityCardEntityType} from '@Components/ai-chat-window/components/entity-card/entity-card.types';
import type {EntityCardAction} from './entity-card-action.types';

interface PdfEntityPayload {
  url: string;
  title?: string;
}

/**
 * Clicking a PDF card opens the generated document in the shared chat lightbox
 * (an inline iframe), keeping the user in the conversation. The lightbox itself
 * offers an "open in new tab" escape hatch for downloading or mobile viewing.
 */
export const pdfEntityCardAction: EntityCardAction<PdfEntityPayload> = {
  entityType: EntityCardEntityType.PDF,
  parsePayload: (raw): PdfEntityPayload => ({
    url: typeof raw.url === 'string' ? raw.url : '',
    title: typeof raw.title === 'string' ? raw.title : undefined,
  }),
  onClick: (payload, ctx): void => {
    if (payload.url === '') {
      return;
    }
    ctx.openPdf(payload.url, payload.title);
  },
};
